import { render, staticRenderFns } from "./appComponent.vue?vue&type=template&id=38d27dfa&scoped=true&"
import script from "./appComponent.vue?vue&type=script&lang=js&"
export * from "./appComponent.vue?vue&type=script&lang=js&"
import style0 from "./appComponent.vue?vue&type=style&index=0&id=38d27dfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d27dfa",
  null
  
)

component.options.__file = "appComponent.vue"
export default component.exports